import styled from 'styled-components'
// themes
import { colors } from 'themes/index'
// utils
import { isColorLight } from 'utils/tree'

export const Header = styled.div`
  position: relative;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.blue500};
  margin-bottom: 20px;

  && {
    svg {
      top: 0;
      right: -12px;
    }
  }
`

export const Content = styled.div`
  padding: 20px;
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;

  color: black;
  padding: 8px;
  border: 1px solid lightgray;
  border-radius: 4px;
  background: #f2f2f2;
`

export const SectionLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${colors.gray400};
`

export const SectionValue = styled.div<{ $color: string }>`
  font-size: 15px;
  line-height: 1.5;
  white-space: pre-wrap;
  background: ${({ $color }) => $color};
  padding: 12px;
  border-radius: 8px;
  font-weight: bold;
  color: ${({ $color }) => (isColorLight($color) ? colors.black : colors.white)};
`

export const Explanation = styled.div`
  font-size: 15px;
  line-height: 1.5;
`

export const Disclaimer = styled.p`
  text-align: center;
  font-size: 12px;
  color: ${colors.gray380};
  margin: 12px 0 0;
`

export const ButtonContainer = styled.div`
  margin-top: 24px;
  display: flex;
  gap: 16px;
  justify-content: end;
`
